(function($) {
	$(document).ready(function(){
		$('#input_5_17').pickadate({
			container: '#field_5_17',
			firstDay: 1,
			format: 'dd/mm/yyyy',
			formatSubmit: 'yyyy-mm-dd',
			hiddenName: true,
			min: new Date()
		});

	});
	
	// Smooth scrolling
	$('a[href*=#]:not([href=#])').click(function() {
		if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
			var target = jQuery(this.hash);
			target = target.length ? target : $('[name="' + this.hash.slice(1) +'"]');
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top - $('header.page-header').outerHeight()
				}, 1000);
				
				return false;
			}
		}
	});
	
	if (window.location.hash) {
		var target = $(window.location.hash);
		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top - $('header.page-header').outerHeight()
			}, 1000);
		}
	}
})(jQuery); // Fully reference jQuery after this point.